export function getNamedOrFallback(name: string | null | undefined, fallback: string): string {
  const trimmed = (name ?? '').trim()
  return trimmed || fallback
}
